import autoComplete from "@tarekraafat/autocomplete.js";

class MpAutocomplete {
	constructor() {
		this.version = "10.2.9"; // autoComplete.js version
		this.request_url = "/autocomplete/";
		this.input_name = "#search-field";
		this.current_search = "";
		this.results_id = "_search_result_list";
		this.close_button = "#close-search";
	}

	init() {
		const autoCompleteJS = new autoComplete({
			selector: this.input_name,
			debounce: 500,
			threshold: 2,
			submit: true,
			data: {
				src: async (query) => {
					this.current_search = query;
					const url = `${this.request_url}?term=${encodeURIComponent(query)}`;
					try {
						const source = await fetch(url, {
							headers: {
								"X-Requested-With": "XMLHttpRequest",
							},
						});
						const data = await source.json();
						return data;
					} catch (error) {
						return error;
					}
				},
				cache: false,
				keys: ["label", "alias"],
				filter: (list) => {
					// Filter duplicates by url in case of multiple data keys usage
					const filteredResults = Array.from(
						new Set(list.map((value) => value.value.url)),
					).map((url) => {
						return list.find((value) => value.value.url === url);
					});
					return filteredResults;
				},
			},
			resultsList: {
				element: (list, data) => {
					list.setAttribute("id", this.results_id);
					list.setAttribute("aria-label", "Search");
					list.setAttribute("tabindex", "-1");
					this.appendAllResults();
				},
				destination: this.input_name,
				position: "afterend",
				tag: "ul",
				noResults: true,
				class: "autoComplete_list",
			},
			resultItem: {
				element: (element, data) => {
					const result = data.value;
					element.innerHTML = `
            <a href="${result.url}"></a>${result.template}
          `;
				},
				tag: "li",
				class: "autoComplete_result",
			},
		});
	}

	appendAllResults() {
		if (!!document.querySelector(".autoComplete_result_all") === false) {
			const $results = document.querySelector(`#${this.results_id}`);
			const $all_results = document.createElement("li");
			$all_results.classList.add("autoComplete_result_all");
			$all_results.innerHTML = `
        <a rel="nofollow" id="all_results" class="btn btn-sm btn-primary font-weight-bold py-1 px-3 text-uppercase" href="/ricerca/?q=${encodeURIComponent(
					this.current_search,
				)}">
          Cerca tutti i risultati per ${this.current_search}<span class="icon"></span>
        </a>
      `;
			$results.appendChild($all_results);
		}
	}

	resetSearch() {
		document.querySelector(this.input_name).value = "";
		this.current_search = "";
	}
}

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	const mainAutocomplete = new MpAutocomplete();
	mainAutocomplete.init();

	// Search buttons
	// --------------------------------------------------
	document.querySelector("#btn-search").addEventListener("click", (e) => {
		document.querySelector(".search-form").style.opacity = "1";
		document.querySelector(".search-form").style.visibility = "visible";
		document.querySelector(mainAutocomplete.input_name).focus();
		mainAutocomplete.resetSearch();
	});

	document
		.querySelector(mainAutocomplete.close_button)
		.addEventListener("click", () => {
			document.querySelector(".search-form").style.opacity = "0";
			document.querySelector(".search-form").style.visibility = "hidden";
			mainAutocomplete.resetSearch();
		});

	document.querySelector("#submit-search").addEventListener("click", () => {
		document.querySelector(".search-form").submit();
	});
});
